import { createContext } from 'use-context-selector';

export interface BoardPluginsContextValue {
  /**
   * Set of capabilities supported across all plugins enabled on the board.
   */
  capabilities: Set<string>;
  /**
   * Set of ids of all plugins enabled on the board
   */
  enabledPlugins: Set<string>;
}

export const emptyBoardPluginsContext: BoardPluginsContextValue = {
  capabilities: new Set(),
  enabledPlugins: new Set(),
};

export const BoardPluginsContext = createContext<BoardPluginsContextValue>(
  emptyBoardPluginsContext,
);
